import { accountingRepository } from "@/service/repository/accountingRepository";
import store from "@/store/index";

const Status = {
	DAY_START: 1,
	INTER_SHIFTS: 2,
	DAY_END:3,
	CASH_MOVEMENT_OUT: 0,
	CASH_MOVEMENT_INFLOW: 1,
	CASH_MOVEMENT_SEARCH: 'search',
};

export const StatusLabels = {
	[Status.DAY_START]: "Inicio de día",
	[Status.INTER_SHIFTS]: "Entre turno",
	[Status.DAY_END]: "Cierre de día",
	[Status.CASH_MOVEMENT_OUT]: "Salida",
	[Status.CASH_MOVEMENT_INFLOW]: "Entrada",
};


const state = {
	Status,

	slots: [],
	cashDrawers: [],
	cardReaders: [],
	venueProviders: [],
	snapshotType:null,
	cashTypeMovement:null,
	cardReaderSnapshotMode: null,
	snapsHotTotalCardAmount: null,

	cashDrawerTransactions: [],
	cashDrawerTransactionsLoading: false,
};

const getters = {
	status: (status) => status.Status,
	statusLabels: () => StatusLabels,

	snapshotType:(state) => state.snapshotType,
	cashTypeMovement:(state) => state.cashTypeMovement,

	cashDrawers(state) {
		return state.cashDrawers;
	},
	mainCashDrawer(state) {
		return state.cashDrawers[0];
	},
	cardReaders(state) {
		return state.cardReaders;
	},
	mainCardReader(state) {
		return state.cardReaders[0];
	},
	slots(state) {
		return state.slots;
	},
	cardReaderSnapshotMode(state) {
		return state.cardReaderSnapshotMode;
	},
	snapsHotTotalCardAmount(state) {
		return state.snapsHotTotalCardAmount;
	},
	venueProviders(state) {
		return state.venueProviders;
	},
	cashDrawerTransactions(state) {
		return state.cashDrawerTransactions;
	},
	cashDrawerTransactionsLoading(state) {
		return state.cashDrawerTransactionsLoading;
	},
	hasSnapshotData: (state) => {
		const hasSlotWithQuantity = state.slots.some(slot => slot.quantity != null && slot.quantity !== 0);
		return (
			state.snapsHotTotalCardAmount != null ||
			// state.cardReaderSnapshotMode != null ||
			// state.snapshotType != null ||
			hasSlotWithQuantity
		);
	}
};

const mutations = {
	initConfigAccounting(state, payload) {
		state.cashDrawers = payload.cashDrawers;
		state.cardReaders = payload.cardReaders;
		state.venueProviders = payload.venueProviders;

		state.slots = state.cashDrawers[0].slots.map((slot) => ({
			...slot,
			quantity: null,
		}));
	},
	setCashDrawers(state, payload) {
		state.cashDrawers = payload.cashDrawers;
	},
	updateSlot(state, payload) {
		state.slots = state.slots.map((slot) => {
			return slot.value === payload.value ? { ...slot, quantity: payload.quantity } : slot;
		});
	},
	setSlots(state, payload) {
		state.slots = payload.slots;
	},
	setsSnapsHotTotalCardAmount(state, payload) {
		state.snapsHotTotalCardAmount = payload.snapsHotTotalCardAmount;
	},
	setCardReaderSnapshotMode(state, payload) {
		state.cardReaderSnapshotMode = payload.mode;
	},
	setSnapshotType(state, payload) {
		state.snapshotType = payload;
	},
	setCashTypeMovement(state, payload) {
		state.cashTypeMovement = payload;
	},
	setCashDrawerTransactions(state, transactions) {
		state.cashDrawerTransactions = transactions;
	},
	setCashDrawerTransactionsLoading(state, loading) {
		state.cashDrawerTransactionsLoading = loading;
	},
/*	resetAccountingSnapshotData(state) {
		state.snapsHotTotalCardAmount = null;
		state.cardReaderSnapshotMode = null;
		state.snapshotType = null;
		if (state.mainCashDrawer && state.mainCashDrawer.slots) {
			state.mainCashDrawer.slots.forEach(slot => {
				slot.quantity = null;
			});
		}
	},*/
	resetAccountingSnapshotData(state) {
		state.snapsHotTotalCardAmount = null;
		state.cardReaderSnapshotMode = null;
		state.snapshotType = null;

		state.slots = state.slots.map(slot => ({
			...slot,
			quantity: null
		}));

		if (state.mainCashDrawer && state.mainCashDrawer.slots) {
			state.mainCashDrawer.slots = state.mainCashDrawer.slots.map(slot => ({
				...slot,
				quantity: null
			}));
		}
	}

};

const actions = {
	async loadAccountingConfig({ commit }) {
		try {
			const config = await accountingRepository.getAccountingConfig();
			if (config.result === 0) {
				commit("initConfigAccounting", config.accountingConfig);
			}
		} catch (error) {
			console.error("Failed to fetch venue config", error);
		}
	},
	async registerAccountingSnapshot({ getters }) {
		try {
			const data = {
				cardReaderId: getters.mainCardReader.id,
				totalCardAmount: getters.snapsHotTotalCardAmount,
				cashDrawerId: getters.mainCashDrawer.id,
				cashDrawerSlots: getters.slots.map((slot) => {
					return { cashDenominationId: slot.cashDenominationId, quantity: slot.quantity };
				}),
				cardReaderSnapshotMode: getters.cardReaderSnapshotMode,
				snapshotType: getters.snapshotType
			};

			return await accountingRepository.registerAccountingSnapshot(data);
		} catch (error) {
			console.error("Error al guardar el snapshot:", error);
		}
	},
	async fetchCashDrawerTransactions({ commit }, payload = {}) {
		commit("setCashDrawerTransactionsLoading", true);
		try {
			const result = await accountingRepository.getCashDrawerTransactions(payload);
			if (result.result === 0) {
				commit("setCashDrawerTransactions", result.cashDrawerTransactions || []);
			} else {
				commit("setCashDrawerTransactions", []);
				await store.dispatch("copilot/showToastError", {
					message: "Error al obtener los movimientos de caja"
				});
			}
			return result;
		} catch (error) {
			commit("setCashDrawerTransactions", []);
			console.error("Error al obtener movimientos de caja:", error);
		} finally {
			commit("setCashDrawerTransactionsLoading", false);
		}
	},
	async getCashDrawerTransactionPrint(_, transactionId) {
		try {
			const result = await accountingRepository.getCashDrawerTransactionPrint(transactionId);
			if (result.result !== 0) {
				await store.dispatch("copilot/showToastError", {
					message: "Error al obtener el ticket de impresión"
				});
			}
			return result;
		} catch (error) {
			console.error("Error al obtener print data:", error);
		}
	},
	async registerCashDrawerTransaction({ getters, rootGetters }, payload) {
		try {
			const currentStaff = rootGetters['copilot/currentStaff'];
			const data = {
				cashDrawerId: getters.mainCashDrawer.id,
				...(currentStaff?.id ? { staffId: currentStaff.id } : {}),
				...Object.fromEntries(
					Object.entries(payload).filter(entry => {
						const value = entry[1];
						return value !== undefined && value !== null && value !== "";
					})
				),
			};
			const result = await accountingRepository.registerCashDrawerTransaction(data);

			if (result.result === 0) {
				await store.dispatch("copilot/showToastSuccess", {
					message: "Transacción de caja registrada correctamente"
				});
			} else {
				await store.dispatch("copilot/showToastError", {
					message: "Ha ocurrido un error registrando el movimiento de caja"
				});
			}
			return result;
		} catch (error) {
			console.error("Error al guardar el snapshot:", error);
		}
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
